import { useEffect, useState } from 'react';
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner, Table } from 'reactstrap';
import axios from '../../services/api_helper';
import deliveryService from '../../services/deliveryNoteService';
import { formatPrice } from '../../helpers/utility';

const endpoints = {
  PURCHASE_RECEIPT: '/api/receipt-notes', CUSTOMER_RETURN: '/api/retours-client',
  SUPPLIER_RETURN: '/api/retours-fournisseur', INVENTORY: '/api/inventaires',
};
export const canOpenMovementDocument = item => Boolean(item && (
  ['CUSTOMER_DELIVERY', 'POS_SALE'].includes(item.sourceDocumentType)
    ? item.referenceDocument : endpoints[item.sourceDocumentType] && item.sourceDocumentId
));

export default function MovementDocumentModal({ movement, onClose }) {
  const [state, setState] = useState({ loading: true, document: null, error: false });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!movement) return;
    let active = true;
    setState({ loading: true, document: null, error: false });
    const request = ['CUSTOMER_DELIVERY', 'POS_SALE'].includes(movement.sourceDocumentType)
      ? deliveryService.findByReference(movement.referenceDocument)
      : axios.get(`${endpoints[movement.sourceDocumentType]}/${encodeURIComponent(movement.sourceDocumentId)}`).then(response => response.data);
    request.then(document => {
      if (!document || !Array.isArray(document.lignes)) throw new Error('Document incomplet');
      if (active) setState({ loading: false, document, error: false });
    }).catch(() => { if (active) setState({ loading: false, document: null, error: true }); });
    return () => { active = false; };
  }, [movement, retry]);
  const doc = state.document;
  const inventory = movement?.sourceDocumentType === 'INVENTORY';
  return <Modal isOpen={Boolean(movement)} toggle={onClose} size="xl" centered scrollable>
    <ModalHeader toggle={onClose}>Document {movement?.referenceDocument}</ModalHeader>
    <ModalBody>
      {state.loading ? <div role="status" className="text-center py-4"><Spinner /><p>Chargement du document…</p></div> : state.error ? <Alert color="danger">Impossible de charger le document. <Button color="link" onClick={() => setRetry(value => value + 1)}>Réessayer</Button></Alert> : doc && <>
        <div className="d-flex flex-wrap gap-4 mb-3">
          <div><small className="text-muted">Date</small><div>{doc.dateOperation || doc.dateLivraison || doc.dateReception || doc.dateInventaire || '—'}</div></div>
          {(doc.clientNom || doc.fournisseurNom) && <div><small className="text-muted">{doc.clientNom ? 'Client' : 'Fournisseur'}</small><div>{doc.clientNom || doc.fournisseurNom}</div></div>}
          <div><small className="text-muted">Magasin</small><div>{doc.entrepotNom || '—'}</div></div>
          <div><small className="text-muted">Statut</small><div>{doc.statut || doc.status || '—'}</div></div>
        </div>
        <p>{doc.lignes.length} article(s)</p>
        <Table responsive bordered className="align-middle">
          <thead><tr><th>Article</th><th>Unité</th><th>{inventory ? 'Quantité comptée' : 'Quantité'}</th><th>{inventory ? 'Quantité théorique' : 'Prix TTC'}</th><th>{inventory ? 'Écart' : 'Montant TTC'}</th></tr></thead>
          <tbody>{doc.lignes.map((line, index) => <tr key={line.id || index}>
            <td><strong>{line.articleNom || line.articleLibelle}</strong><div className="small text-muted">{line.articleCodeBarre || line.codeBarre || line.articleCode}</div></td>
            <td>{line.unite || '—'}</td><td>{inventory ? line.quantitePhysique ?? '—' : line.quantiteLivree ?? line.quantiteRecue ?? line.quantiteRetournee ?? line.quantite ?? '—'}</td>
            <td>{inventory ? line.quantiteTheorique ?? '—' : line.prixUnitaireTTC == null ? '—' : formatPrice(line.prixUnitaireTTC)}</td>
            <td>{inventory ? line.ecart ?? '—' : line.montantTTC == null ? '—' : formatPrice(line.montantTTC)}</td>
          </tr>)}{!doc.lignes.length && <tr><td colSpan={5} className="text-center">Aucun article.</td></tr>}</tbody>
        </Table>
        {!inventory && <div className="text-end">
          <div>Total HT : <strong>{formatPrice(doc.montantTotalHT ?? doc.montantHT ?? 0)}</strong></div>
          <div>TVA : <strong>{formatPrice(doc.montantTotalTaxe ?? doc.montantTVA ?? 0)}</strong></div>
          <div>Total TTC : <strong>{formatPrice(doc.montantTotalTTC ?? doc.montantTTC ?? 0)}</strong></div>
        </div>}
      </>}
    </ModalBody><ModalFooter><Button color="secondary" onClick={onClose}>Fermer</Button></ModalFooter>
  </Modal>;
}
